import axios from 'axios';
import { GetStaticProps } from 'next';
import getConfig from 'next/config';
import { Suspense, useEffect } from 'react';
import { ClearInNavbar } from '../../../components/Navbar/ClearNavbar';
import {
  getCommitDate,
  getFormatedDate,
} from '../../../components/NumberSearch/utils';
import { b2cData } from '../../../components/cms/layout/components/header';
import { IncomeTaxPage } from '../../../components/income-tax';
import {
  canonical,
  description,
  keywords,
  pageTitle,
} from '../../../components/income-tax/itr-contants';
import { ITRService } from '../../../components/income-tax/itr.service';
import { ApiPlan } from '../../../components/income-tax/page-sections/hero-section/view-new-plan-modal-content/types';
import { itrData } from '../../../components/income-tax/static/data';
import { ITR_DATA } from '../../../components/income-tax/static/types';
import { ITR_COMMIT_DATA_LINK } from '../../../constants/itrContants';
import { Meta } from '../../../layout/Meta';
import { FM_ACTIONS } from '../../../utils/UtilFunctions';
import { identifyUserInNetcore } from '../../../utils/netcore';
import { staticPropsWrapper } from '../../../utils/static-pages/utils';
import { handleTrack } from '../../../utils/tracker';
import { ButtonVariants } from '../../../components/Atoms/Button';
import { LoginButton } from '../../../components/Header/LoginButton';
import dynamic from 'next/dynamic';
import { getObjectByKey } from '../../../components/S/pricing/utils';
import {
  PARTNER_META_KEY,
  PRICING_META_KEY,
} from '../../../components/partner-pages/constants';
import PartnerPageDataService from '../../../components/partner-pages/services/partner-pages.service';
import { returnNoProps } from '../../../utils/UtilFunctions';
import { TEASPlans } from '../../../components/S/pricing/types';

const StickyCTA = dynamic(
  () =>
    import('../../../components/CTA/StickyCTA').then((mod) => mod.StickyCTA),
  { suspense: true }
);

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
interface INCOME_TAX_PROPS {
  lastUpdatedDate: string;
  plans: ApiPlan[];
  planData: TEASPlans;
}

const IncomeTax = ({
  lastUpdatedDate,
  planData,
  plans,
}: INCOME_TAX_PROPS): JSX.Element => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.parentCategory = 'itr_landing_new_variant';
      handleTrack({
        label: window.location.pathname,
        action: FM_ACTIONS.pageview,
      });
    }
  }, []);
  useEffect(() => {
    const email = localStorage.getItem('userEmail');

    if (email) {
      identifyUserInNetcore(email);
    }
  }, []);
  const BASE_URL = publicRuntimeConfig.CLEARTAX_DOMAIN;

  const customRightCTA = (
    <LoginButton
      buttonColor={ButtonVariants.pinkfilled}
      link={`${BASE_URL}/filing?showplan=1&utm_ref=itr_landing_new_variant_navbar_button}`}
      btnClasses="text-base font-bold px-6 py-3 sm:px-2 sm:py-2 border-blue-350 border-[1.5px] border-solid"
      btnText="Login/Sign-up"
    />
  );
  return (
    <div className="relative">
      <ClearInNavbar
        data={b2cData}
        showPlanVariant={'variantA'}
        bgColor="bg-pink-brand"
        customRightCTA={customRightCTA}
      />
      <Meta
        title={pageTitle}
        description={description}
        canonical={canonical}
        keywords={keywords}
        isItr={true}
        img="https://assets.clear.in/cleartax/images/1753522630_diy_itrhomepage.png"
      />
      <IncomeTaxPage
        itrData={itrData as unknown as ITR_DATA}
        isVariant={false}
        lastUpdatedDate={lastUpdatedDate}
        pricingPlanData={planData}
        diyPlans={plans}
      />
      <Suspense fallback={<div>Loading CTA...</div>}>
        <StickyCTA
          buttonText={'Start Filing'}
          buttonStyle={ButtonVariants.bluefilled}
          link={`${BASE_URL}/filing?utm_ref=itr_2025_organic_itr_homepage_hero_fold_cta`}
          label="hero_cta"
        />
      </Suspense>
    </div>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  async () => {
    const lastUpdatedDateProps = await getITRCommitDate();
    const plansProps = await ITRService.getPlans();
    try {
      const resMeta = await PartnerPageDataService.getMetaDataMulti(
        [PARTNER_META_KEY, PRICING_META_KEY].join(',')
      );
      let responseDataMeta;
      if (resMeta.data) {
        responseDataMeta = resMeta.data;
        const pricePageData = getObjectByKey(
          responseDataMeta,
          PRICING_META_KEY
        );
        const planData = pricePageData?.eas_plans;
        return {
          props: {
            planData: planData,
            ...lastUpdatedDateProps.props,
            ...plansProps,
          },
        };
      }
    } catch (error) {
      return returnNoProps();
    }
    return returnNoProps();
  }
);

async function getITRCommitDate(): Promise<{
  props: { lastUpdatedDate: string };
}> {
  let date;
  const { githubToken } = serverRuntimeConfig;
  if (githubToken) {
    try {
      const commitData = await axios.get(ITR_COMMIT_DATA_LINK, {
        headers: {
          Authorization: `token ${githubToken}`,
          Accept: 'application/vnd.github+json',
        },
      });
      date = await getCommitDate(commitData);
    } catch (e) {
      console.log(e);
      date = await getFormatedDate(new Date());
    }
  } else {
    date = await getFormatedDate(new Date());
  }

  return {
    props: {
      lastUpdatedDate: date,
    },
  };
}

export default IncomeTax;
